<script setup lang="ts">
import { ref, watch } from 'vue'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/24/solid'
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { typeTranslations, typeForAgent } from '@/utils/config/constants/documents-types';
import { computePermissionForCurrentUser } from '../../utils/directives/v-permission';

const selected = ref("OTHER");
const documentTypes = computePermissionForCurrentUser(["UPCLAIM_ADMIN", "LAWYER", "PLEADING_LAWYER"])
  ? typeTranslations
  : typeForAgent

const emits = defineEmits<{
  (event: 'selectionUpdate', documentType: string | undefined) : void
}>();

watch(selected, (newValue) => {
  if (newValue) {
    emits('selectionUpdate', newValue as string);
  }
});
</script>
<template>
  <Listbox as="div" v-model="selected">
    <ListboxLabel class="block my-2 text-sm font-medium text-gray-700">
      Type de document
    </ListboxLabel>
    <div class="relative mt-1 trans">
      <ListboxButton class="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-md shadow-sm cursor-default focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
        <span class="block truncate">
          {{ documentTypes[selected] }}
        </span>
        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronUpDownIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>

      <transition
        name="slide-fade"
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-200 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <ListboxOptions class="relative z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          <ListboxOption as="template"
            v-for="documentType of Object.keys(documentTypes)" :key="documentType"
            :value="documentType"
            v-slot="{ active, selected }"
          >
            <li :class="[active ? 'text-white bg-blue-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
              <div class="flex items-center">
                <span :class="[
                  selected ? 'font-semibold' : 'font-normal', 'block truncate',
                ]">
                  {{ documentTypes[documentType] }}
                </span>

                <span v-if="selected" :class="[active ? 'text-white' : 'text-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                  <CheckIcon class="w-5 h-5" aria-hidden="true" />
                </span>
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>

</template>